
import './style.less'

import { h, Fragment } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { withHydration } from '@util/hydrate'
import { useFontsLoaded } from '@util/useFontsLoaded'
import classnames from 'classnames'


const NEWLINE_MARKER = '|'


const convertNewlines = string => {
	return string.replace(/<br\s*\/?>/gi, " | ").replace(/\s+/g, ' ')
}

const wordsFromLine = (words) => {
	return words.split(' ').map(word => {
		if (word === '|') return <br />
		return <>
			<span class="title-text__word">
				<span class="title-text__word__inner" dangerouslySetInnerHTML={{ __html: word }} />
			</span>
			{' ' /* add a space after each item */}
		</>
	})
}


const TitleText = ({ lines = [], trigger : triggerInitial = true }) => {

	if (!Array.isArray(lines)) return null

	const first = convertNewlines(lines[0] || "")
	const second = convertNewlines(lines[1] || "")

	const fontsLoaded = useFontsLoaded()
	const [trigger, setTrigger] = useState(triggerInitial && fontsLoaded)

	useEffect(() => {
		// only trigger the animation once
		if (triggerInitial === true && trigger !== true) 
			setTrigger(triggerInitial)
	}, [triggerInitial])

	const classes = classnames(
		'title-text', 
		trigger && 'title-text--animate'
	)

	return <div className={classes}>
		{first && (
			 <div className="title-text__line">
				<div className="title-text__highlight">
					{wordsFromLine(first)}
				</div>
			</div>
		)}
		{second && (
			<div className="title-text__line title-text__line--lower">
				<div className="title-text__highlight">
					{wordsFromLine(second)}
				</div>
			</div>	
		)}
	</div>
}

export const TitleTextLive = withHydration(TitleText)

export default TitleText
